"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "tergu": {
    "7c64dfbb": [{
      "hkey": "b777762f",
      "slug": "tergu",
      "name": "Tergu",
      "primary": true,
      "skipSearch": false
    }],
    "bivio": [{
      "hkey": "b777762f",
      "slug": "tergu",
      "name": "Tergu",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "eec6abc8": [{
      "hkey": "b777762f",
      "slug": "tergu",
      "name": "Tergu",
      "primary": true,
      "skipSearch": false
    }],
    "chiesa": [{
      "hkey": "b777762f",
      "slug": "tergu",
      "name": "Tergu",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fba1fc31": [{
      "hkey": "b777762f",
      "slug": "tergu",
      "name": "Tergu",
      "primary": true,
      "skipSearch": false
    }],
    "funtana-de-multa": [{
      "hkey": "b777762f",
      "slug": "tergu",
      "name": "Tergu",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "62380d06": [{
      "hkey": "b777762f",
      "slug": "tergu",
      "name": "Tergu",
      "primary": true,
      "skipSearch": false
    }],
    "ischina-de-mucciu": [{
      "hkey": "b777762f",
      "slug": "tergu",
      "name": "Tergu",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b8a8c4db": [{
      "hkey": "b777762f",
      "slug": "tergu",
      "name": "Tergu",
      "primary": true,
      "skipSearch": false
    }],
    "monte-curria": [{
      "hkey": "b777762f",
      "slug": "tergu",
      "name": "Tergu",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9977b9a8": [{
      "hkey": "b777762f",
      "slug": "tergu",
      "name": "Tergu",
      "primary": true,
      "skipSearch": false
    }],
    "pedraia": [{
      "hkey": "b777762f",
      "slug": "tergu",
      "name": "Tergu",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3e573046": [{
      "hkey": "b777762f",
      "slug": "tergu",
      "name": "Tergu",
      "primary": true,
      "skipSearch": false
    }],
    "riu-la-minda": [{
      "hkey": "b777762f",
      "slug": "tergu",
      "name": "Tergu",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "08e1634e": [{
      "hkey": "b777762f",
      "slug": "tergu",
      "name": "Tergu",
      "primary": true,
      "skipSearch": false
    }],
    "serra-e-sa-jaga": [{
      "hkey": "b777762f",
      "slug": "tergu",
      "name": "Tergu",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e1fb5d84": [{
      "hkey": "b777762f",
      "slug": "tergu",
      "name": "Tergu",
      "primary": true,
      "skipSearch": false
    }],
    "su-monte": [{
      "hkey": "b777762f",
      "slug": "tergu",
      "name": "Tergu",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;